// Vue 3 directive for Bootstrap tooltip

//import { Tooltip } from 'bootstrap';
import { waitForBootstrap } from '../bootstrap-helpers';

function bsTooltip(el, binding) {
    const Tooltip = window.bootstrap?.Tooltip;

    let trigger;
    if (binding.modifiers.focus || binding.modifiers.hover || binding.modifiers.click) {
        const t = [];
        if (binding.modifiers.focus) t.push('focus');
        if (binding.modifiers.hover) t.push('hover');
        if (binding.modifiers.click) t.push('click');
        trigger = t.join(' ');
    }

    // Store the instance on the element itself
    el._tooltipInstance = Tooltip.getOrCreateInstance(el, {
        title: binding.value || '',
        placement: binding.arg || 'top',
        trigger: trigger || 'hover focus',
        html: binding.modifiers.html || false
    });
}

export default {
    mounted(el, binding) {
        waitForBootstrap(() => bsTooltip(el, binding));
    },
    updated(el, binding) {
        if (el._tooltipInstance) {
            el._tooltipInstance.dispose();
        }
        waitForBootstrap(() => bsTooltip(el, binding));
    },
    unmounted(el) {
        if (el._tooltipInstance) {
            el._tooltipInstance.dispose();
            delete el._tooltipInstance;
        }
    }
};